import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App.tsx";
import "./index.css";
import { registerServiceWorker } from "./lib/push";

createRoot(document.getElementById("root")!).render(<App />);

// Register the push/PWA service worker (no-op where unsupported).
registerServiceWorker();

const MIN_SPLASH_MS = 1800;
const splashStart = performance.now();

const dismissSplash = () => {
  const splash = document.getElementById("splash");
  if (!splash) return;
  splash.classList.add("splash-out");
  setTimeout(() => splash.remove(), 550);
};

// Respect minimum display time so the animation is always visible,
// regardless of how fast the data loads.
const scheduleDismiss = () => {
  const elapsed = performance.now() - splashStart;
  const remaining = Math.max(0, MIN_SPLASH_MS - elapsed);
  setTimeout(dismissSplash, remaining);
};

// Phase 2 — after React's first paint, clear the background so the app
// is visible behind the floating logo animation.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById("splash");
    if (splash) splash.classList.add("splash-bg-clear");
  });
});

// Phase 3 — skip splash immediately if the user is unauthenticated (they'll
// be redirected to /login and we don't want a 5-second wait there).
// Uses the same localStorage key pattern as src/lib/api.ts → getStoredToken().
const shouldSkipSplash = (() => {
  try {
    if (window.location.pathname === "/login") return true;
    const tenant = localStorage.getItem("besthr_active_tenant") ?? "public";
    const token = localStorage.getItem(`besthr_${tenant}_token`);
    return !token; // No stored JWT → will be redirected to login
  } catch {
    return false;
  }
})();

if (shouldSkipSplash) {
  // Remove immediately — no animation, no minimum display time
  const splash = document.getElementById("splash");
  if (splash) splash.remove();
} else {
  // Dismiss when the dashboard signals it's ready, honouring the minimum.
  // Fallback: auto-dismiss after 5 s for authenticated non-dashboard routes.
  const fallback = setTimeout(scheduleDismiss, 5000);
  document.addEventListener(
    "app-ready",
    () => { clearTimeout(fallback); scheduleDismiss(); },
    { once: true },
  );
}
